/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontSocial_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontHead_user$ref: FragmentReference;
export type StorefrontHead_user = {|
  +serviceId: ?string,
  +$fragmentRefs: StorefrontSocial_user$ref,
  +$refType: StorefrontHead_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontHead_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontSocial_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'be37b972407a12aa7fb1298dc9b08296';
module.exports = node;
